import { render } from "./TenderTable.vue?vue&type=template&id=ef1ac332"
import script from "./TenderTable.vue?vue&type=script&lang=js"
export * from "./TenderTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__